module.exports = __webpack_public_path__ + "static/media/card-front.fa52c4d4.svg";